import { Action } from "../../../actions/actions";
import { HallsActionTypes } from "../actions/actionTypes";

export enum CreationModes {
    ADD_HALL = "ADD_HALL",
    EDIT_HALL = "EDIT_HALL",
    ADD_SERVER = "ADD_SERVER",
    EDIT_SERVER = "EDIT_SERVER",
    UPLOAD_CONFIG = "UPLOAD_CONFIG",
    CLONE_SERVER = "CLONE_SERVER"
}

export function creationMode(
    state: string | null = null,
    action: Action
): string | null {
    switch (action.type) {
        case HallsActionTypes.CREATION_MODE_CHANGE:
            return action.payload.mode;
        case HallsActionTypes.CREATE_HALL_RESET:
        case HallsActionTypes.CREATE_HALL_SUCCESS:
        case HallsActionTypes.UPDATE_HALL_SUCCESS:
        case HallsActionTypes.CREATE_SERVER_SUCCESS:
        case HallsActionTypes.CLONE_SERVER_SUCCESS:
        case HallsActionTypes.UPDATE_SERVER_SUCCESS:
            return null;
        default:
            return state;
    }
}
